import React from 'react';
import { Button } from './ui/button';
import { Bell, BellOff, CheckCircle, XCircle } from 'lucide-react';

const StatusMessage = ({ message }) => {
  if (!message.text) return null;

  return (
    <div className={`flex items-center gap-2 mb-4 p-3 rounded-lg ${
      message.type === 'success' 
        ? 'bg-green-900/20 border border-green-900/30 text-green-400' 
        : 'bg-red-900/20 border border-red-900/30 text-red-400'
    }`}>
      {message.type === 'success' ? (
        <CheckCircle className="w-5 h-5 flex-shrink-0" />
      ) : (
        <XCircle className="w-5 h-5 flex-shrink-0" />
      )}
      <span className="text-sm">{message.text}</span>
    </div>
  );
};

const PushNotificationUI = ({ 
  isSubscribed, 
  loading, 
  message, 
  onSubscribe, 
  onUnsubscribe 
}) => {
  return (
    <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 max-w-2xl">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-full bg-[#B8860B]/20 flex items-center justify-center flex-shrink-0">
          {isSubscribed ? (
            <Bell className="w-6 h-6 text-[#B8860B]" />
          ) : (
            <BellOff className="w-6 h-6 text-gray-400" />
          )}
        </div>
        
        <div className="flex-grow">
          <h3 className="text-white font-bold text-xl mb-2">
            Appointment Reminders & Special Offers
          </h3>
          <p className="text-gray-400 mb-4">
            {isSubscribed 
              ? 'You&apos;re subscribed! We&apos;ll notify you about upcoming appointments and exclusive promotions.'
              : 'Never miss an appointment! Get reminders 24 hours before your service and be first to know about special deals.'}
          </p>

          <StatusMessage message={message} />

          <div className="flex items-center gap-3">
            {!isSubscribed ? (
              <Button
                onClick={onSubscribe}
                disabled={loading}
                className="bg-[#B8860B] hover:bg-[#C8960B] text-[#111216] font-semibold"
              >
                <Bell className="w-4 h-4 mr-2" />
                {loading ? 'Enabling...' : 'Enable Notifications'}
              </Button>
            ) : (
              <Button
                onClick={onUnsubscribe}
                disabled={loading}
                variant="outline"
                className="border-2 border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
              >
                <BellOff className="w-4 h-4 mr-2" />
                {loading ? 'Disabling...' : 'Disable Notifications'}
              </Button>
            )}
          </div>

          <p className="text-gray-500 text-xs mt-3">
            You can unsubscribe at any time. We respect your privacy and won't spam you.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PushNotificationUI;
